// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2oXXe","rootSuccess":"CompleteLink_rootSuccess__14fLD","rootFailure":"CompleteLink_rootFailure__2FFNC","isDisabled":"CompleteLink_isDisabled__3TwxO"};